import React from 'react';
import RectButton from '../../customized/RectButton';
import { useWebContents } from '../../hooks/useWebContents';
import { renderContentWithLineBreaks } from '../../utils/renderContentWithLineBreaks';
import { useImages } from '../../hooks/useImages';

const GUIDS = {
  oneEarth: '05efe53c-c71a-4aa3-a5ed-24bb875cdfe1',
};

const HeroSection: React.FC = () => {

  const contents = useWebContents(GUIDS, 'Home');
  const heroImage = useImages(GUIDS.oneEarth)?.image;

  return (
    <section
      className="relative flex flex-col items-center justify-center text-center bg-cover bg-center min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] pt-16 sm:pt-0"
      style={{ backgroundImage: heroImage ? `url(${heroImage})` : undefined }}
    >

      <div className="absolute inset-0 bg-black/40 z-0" />
      <div className="relative z-10 flex flex-col items-center justify-center py-12 px-4 sm:py-20 sm:px-8">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white drop-shadow-lg mb-3 sm:mb-4">
          {contents.oneEarth.heading}
        </h1>
        <h2 className="text-base sm:text-xl md:text-2xl text-white drop-shadow mb-4 sm:mb-6 max-w-2xl">
          {renderContentWithLineBreaks(contents.oneEarth.content)}
        </h2>

        <div className="flex flex-col sm:flex-row w-full max-w-xs sm:max-w-sm mx-auto gap-6 justify-center mt-10 sm:mt-6">

          <RectButton
            children="Residential"
            onClick={() => window.location.href = "#signUp"}
            className="w-80 text-2xl"
          />

          <RectButton
            children="Commercial"
            onClick={() => window.location.href = "#commercial"}
            className="w-80 text-2xl"
          />
        </div>

        {/* <div className="mt-4 flex w-full max-w-xs sm:max-w-sm mx-auto justify-center">
          <RectButton
            children="Compost Order Form"
            onClick={() => window.location.href = "#/orderCompost"}
            className="w-full text-xl sm:text-2xl"
          /> 
        </div>*/}
      </div>
    </section>
  )
};

export default HeroSection;
